import { render } from "./클리닉FAQ.vue?vue&type=template&id=786c1eee"
import script from "./클리닉FAQ.vue?vue&type=script&lang=js"
export * from "./클리닉FAQ.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__